/* eslint-disable */
import React from 'react';
import LegalPage from '../components/LegalPage';

const ShippingPolicy = () => (
  <LegalPage eyebrow="FROM ATELIER TO DOORSTEP" title="Shipping" italicTail="Policy.">
    <h2>Order Processing</h2>
    <p>Orders are generally processed within <strong>1–3 business days</strong> after payment confirmation.</p>

    <h2>Delivery Time</h2>
    <p>Estimated delivery timelines:</p>
    <ul>
      <li><strong>Metro cities</strong> — 2–5 business days</li>
      <li><strong>Other cities</strong> — 4–8 business days</li>
      <li><strong>Remote locations</strong> — 5–10 business days</li>
    </ul>
    <p className="text-sm text-[#5a4a3e]">Actual delivery times may vary due to circumstances beyond our control.</p>

    <h2>Shipping Charges</h2>
    <p>Shipping charges will be displayed during checkout. Free shipping may be offered during promotions or above specified order values.</p>

    <h2>Order Tracking</h2>
    <p>Tracking details will be shared via email, SMS, or WhatsApp once the order is shipped.</p>

    <h2>Delivery Issues</h2>
    <p>If your order is marked delivered but not received, please contact us within <strong>48 hours</strong>.</p>
  </LegalPage>
);

export default ShippingPolicy;
